import { useEffect } from 'react'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import { Stack } from '@leroy-merlin-br/backyard-react-ui'

import { Actions as CouponActions } from 'lmcv/redux/modules/coupon'
import { Actions as ProActions } from 'lmcv/redux/modules/professional'
import { useProfileLoyalty } from 'lmcv/hooks/use-profile-loyalty'

import { CarouselPercentage, CarouselMoney } from './components/Carousel'
import { Professional } from './components/Professional'
import { BannerWebAwards } from './components/BannerWebAwards'
import Preferences from './components/Preferences'

const Home = () => {
  const dispatch = useDispatch()
  const coupons = useSelector(state => state.coupon, shallowEqual)
  const user = useSelector(state => state.user.get.payload, shallowEqual)
  const { professional } = useSelector(state => state, shallowEqual)

  const [profileLoyalty] = useProfileLoyalty()

  const { externalCatalogs } = profileLoyalty

  const hasCatalogs = externalCatalogs?.length

  useEffect(() => {
    dispatch(CouponActions.getMoney(1, 'available', 10))
    dispatch(CouponActions.getPercentage())
    dispatch(CouponActions.getActivated(1, 'money', 10))
  }, [dispatch])

  useEffect(() => {
    if (user.status !== 7 && user.status !== 8) {
      dispatch(ProActions.getProfessional())
    }
  }, [dispatch, user])

  return (
    <Stack>
      <CarouselPercentage data={coupons.percentage} />
      {!user.hasPreferences && (
        <Preferences hasPreferences={user.hasPreferences} />
      )}

      {hasCatalogs && <BannerWebAwards catalogs={externalCatalogs} />}

      <CarouselMoney data={coupons} />
      <Professional data={professional} />
    </Stack>
  )
}

export default Home
